<template>
  <div ref="modaldes" class="modal" tabindex="-1" role="dialog" id="modal-ncobradorprog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <p class="text-center mb-1 mt-4">
            <b>Se asignará un responsable de cobranza a todos los estudiantes del programa: </b>
          </p>
          <p class="mb-0 mt-0 text-center">{{ prog.nombre_compuesto }}</p>
          <p class="mb-0 mt-0 text-center">{{ prog.inscripciones.length }} participantes.</p>

          <div class="xcard">
            <p class="mb-0 mt-5"><span class="text-danger">*</span> Seleccione al responsable para la cobranza:</p>
            <div>
              <v-combobox
                v-model="input.responsable"
                :items="responsables"
                label="Responsable de cobranza"
                :loading="loadingusuarios"
                :disabled="loading"
                hide-details
                outlined
                dense
              ></v-combobox>
            </div>

            <XFechas ref="xfechas" />
          </div>

          <p class="text-center text-danger">
            <b>{{ msg }}</b>
          </p>
          <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="validar()" :disabled="loading || exitoso" type="button" class="btn btn-azul white--text">
            Asignar al programa
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import XFechas from '@/components/AAsignarCobradorFechas.vue';
  export default {
    data() {
      return {
        msg: '',
        loading: false,
        exitoso: false,
        loadingusuarios: false,
        responsables: [],
        input: {
          responsable: null,
        },
        prog: { nombre_compuesto: null, inscripciones: [] },
      };
    },
    watch: {},
    components: { XFechas },
    methods: {
      open(prog) {
        window.console.log('asignar cobrador prog', prog);
        this.prog = prog;
        this.exitoso = false;
        this.msg = '';
        this.input.responsable = null;
        this.$refs.xfechas.load();
        this.getusuariosbycargo();
        window.$('#modal-ncobradorprog').modal('show');
      },
      validar() {
        this.msg = '';
        this.loading = false;
        let inicio = this.$refs.xfechas.getfechainicio();
        let fin = this.$refs.xfechas.getfechafin();
        window.console.log(inicio, fin);
        if (!this.input.responsable) {
          this.msg = 'Seleccione a un responsable';
          return;
        }
        if (!inicio) {
          this.msg = 'Seleccione la fecha de inicio';
          return;
        }
        /* if (!fin) {
          this.msg = 'Seleccione la fecha de finalizacion';
          return;
        } */
        let di = new Date(inicio);
        if(fin){
          let fi = new Date(fin);
          if (fi.getTime() <= di.getTime()) {
            this.msg = 'La fecha final debe ser superior a la fecha de inicio';
            return;
          }
        }
        this.enviardatos(inicio, fin);
      },
      getusuariosbycargo() {
        this.responsables = [];
        this.loading = true;
        const vue = this;
        let idsede = this.$store.state.CARGO.sede.id;
        let datos = [];
        let url1 = `${process.env.VUE_APP_API_REST}/api/v1/user/cargos?sede_id=${idsede}&cargos=14`;
        let url2 = `${process.env.VUE_APP_API_REST}/api/v1/user/cargos?sede_id=${idsede}&cargos=15`;
        let url3 = `${process.env.VUE_APP_API_REST}/api/v1/user/cargos?sede_id=${idsede}&cargos=19`;
        const promise1 = xaxios.get(url1);
        const promise2 = xaxios.get(url2);
        const promise3 = xaxios.get(url3);
        window.console.log(url1);

        Promise.all([promise1, promise2, promise3])
          .then(function(values) {
            let data1 = values[0];
            let data2 = values[1];
            let data3 = values[2];
            window.console.log('>>', data1.data, data2, data3);
            vue.llenardatos(data1, datos);
            vue.llenardatos(data2, datos);
            vue.llenardatos(data3, datos);
            vue.responsables = datos;
            window.console.log('>>', datos);
            vue.loading = false;
          })
          .catch((e) => {
            vue.$emit('dataloaded');
            window.console.error(e);
            vue.loading = false;
          });
      },
      llenardatos(data, datos) {
        if (data.data != '') {
          data.data.data.forEach((e) => {
            e.id = e.usuario_id;
            e.text = datos.length + 1 + '.- ' + e.nombre + ' ' + e.primer_apellido + ' ' + e.segundo_apellido;
            datos.push(e);
          });
        }
      },
      enviardatos(inicio, fin) {
        const vue = this;
        this.loading = true;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/asignacion/masivo`;
        let data = {
          fecha_inicio: inicio,
          fecha_fin: fin,
          programa_id: this.prog.id,
          usuario_id: parseInt(this.input.responsable.id),
        };
        window.console.log(data);

        xaxios
          .post(url, data)
          .then((data) => {
            window.console.log(data);
            vue.msg = data.data.data;
            vue.loading = false;
            vue.exitoso = true;
            let noti = { group: 'authx', title: 'Mensaje', text: vue.msg, duration: 5000 };
            vue.$notify(noti);
            vue.$emit('onnew');
            window.$('#modal-ncobradorprog').modal('hide');
          })
          .catch((error) => {
            window.console.error(error);
            vue.loading = false;
          });
      },
    },
    mounted() {},
  };
</script>
